const getLoading = (state: any) => state.storeTable.loading;
const getPagination = (state: any) => state.storeTable.pagination;
const getRowsPerPage = (state: any) => state.storeTable.pagination.rowsPerPage;
const getPage = (state: any) => state.storeTable.pagination.page;
const getItems = (state: any) => state.storeTable.items;

export default {
  getLoading,
  getPagination,
  getRowsPerPage,
  getPage,
  getItems
};
